import { jwtDecode } from 'jwt-decode';

export function checkAuthorized(token: string): boolean {
  if (!token) {
    return false;
  }

  try {
    const decodedToken = jwtDecode(token);
    const exp = decodedToken.exp;

    if (!exp) {
      return false;
    }

    return !(exp < Date.now() / 1000);
  } catch (error) {
    console.error(error);
    return false;
  }
}
